import { buildUrl } from "neetocommons/utils/general";
import { replace } from "ramda";

export const facebookShareLink = ({ url }) =>
  buildUrl("https://www.facebook.com/sharer/sharer.php", { u: url });

export const linkedInShareLink = ({ url, title }) =>
  buildUrl("https://www.linkedin.com/sharing/share-offsite", {
    mini: true,
    text: `${title} ${url}`,
  });

export const twitterShareLink = ({ url, title }) =>
  buildUrl("http://twitter.com/share", { text: title, url });

export const downloadCanvas = (canvas, options = {}) => {
  const { name = "image", extension = "png" } = options;

  const canvasUrl = canvas.toDataURL(`image/${extension}`);
  const element = document.createElement("a");
  element.href = canvasUrl;
  element.download = `${name}.${extension}`;
  element.click();
  element.remove();
};

export const copyCanvasToClipboard = async (canvas, handleDownloadQRCode) => {
  if (!canvas) return;

  try {
    const blob = await new Promise(resolve => canvas.toBlob(resolve));
    if (!blob) return;

    const clipboardItem = new ClipboardItem({ [blob.type]: blob });
    navigator.clipboard.write([clipboardItem]);
  } catch {
    handleDownloadQRCode();
  }
};

export const getPathname = url => new URL(url).pathname.slice(1);

export const getPrefixFromUrl = url => `${new URL(url).origin}/`;

export const truncatePrefix = (inputElement, prefixText) => {
  const parentElement = inputElement.parentElement;
  const prefixElement = parentElement.querySelector(".neeto-ui-input__prefix");

  const { fontSize } = getComputedStyle(inputElement);
  const averageCharWidth = parseFloat(fontSize) * 0.6;

  const requiredInputWidth = inputElement.value.length * averageCharWidth;
  const prefixWidth = parentElement.offsetWidth - requiredInputWidth;

  const maxPrefixChars = Math.max(
    Math.floor(prefixWidth / averageCharWidth),
    5
  );

  prefixElement.textContent =
    maxPrefixChars < prefixText.length
      ? `...${prefixText.slice(-maxPrefixChars)}`
      : prefixText;
};

export const normalizeEditablePath = replace(/[^a-z0-9&?=._-]/gi, "");
